import "./index.sass";

interface ImageMEFProps {
  src: string;
}

const ImageMEF = ({ src }: ImageMEFProps) => {
  return (
    <div id="image-mef">
      <div className="image-mef">
        <img style={{ maxHeight: "var(--height-650)" }} src={src} alt="" />
      </div>
    </div>
  );
};

export default ImageMEF;
